import { render } from "./DFormTextarea.vue?vue&type=template&id=60794ba2"
import script from "./DFormTextarea.vue?vue&type=script&lang=js"
export * from "./DFormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__